<template>
	<base-card class="service_pack_list" :title="title">
		<van-grid :column-num="3" class="tools_grid" :border="false">
			<van-grid-item>
				<van-badge :content="parseInt(videoNumber)||''">
					<div class="tools_grid__icon" @click="goConsult(1)">
						<img class="tools_grid__icon__inner" src="../../../assets/icon/chat_video.png" alt="" />
					</div>
				</van-badge>
				<span class="tools_grid__text van-multi-ellipsis--l2">视频咨询</span>
			</van-grid-item>
			<van-grid-item>
				<van-badge :content="parseInt(voiceNumber)||''">
					<div class="tools_grid__icon" @click="goConsult(2)">
						<img class="tools_grid__icon__inner" src="../../../assets/icon/chat_audio.png" alt="" />
					</div>
				</van-badge>
				<span class="tools_grid__text van-multi-ellipsis--l2">语音咨询</span>
			</van-grid-item>
		</van-grid>

		<div
			v-for="(item, index) in list"
			:key="item.id"
			class="service_pack_list__item"
			:class="getServicePackItemStyle(index)"
		>
			<HomePackageItem
				:label="item.title"
				:type="getServicePackItemStyle(index)"
				@click="$router.push(`/servicePack/detail/${ item.id }?orderSource=1`)"
			/>
		</div>
	</base-card>
</template>

<script>
import HomePackageItem from './home-package-item.vue'
export default {
    name: 'servicePackList',
    components: { HomePackageItem },
    props: {
        title: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => ([])
        },
        itemList: {
            type: Array,
            default: () => ([])
        },
        videoNumber: {
            type: [Number, String],
            default: ''
        },
        voiceNumber: {
            type: [Number, String],
            default: ''
        }
    },
    computed: {
        getConsultOrder () {
            return this.$store.getters['consult/getOrderDetail'] || {}
        },
    },
    methods: {
        goConsult (type) {
            let obj = JSON.parse(JSON.stringify(this.getConsultOrder))
            obj['consultContent'] = ''
            obj['consultFilePathList'] = []
            obj['isDeduct'] = 1
            this.$store.commit('consult/SET_ORDER_DETAIL', obj)
            this.$router.push(`/physicianVisits/subscribe?type=${type}`)
        },
        // 获取服务项的标签
        getServiceItemBadge ({ remainingQuantity, remainingDay, isPay = true }) {
            if (!isPay) return null
            if (remainingDay < 0) return '已过期'
            if (remainingDay < 7) return '即将过期'
            if (remainingQuantity > 0) return `剩${remainingQuantity}`
            return null
        },
        getServicePackItemStyle (index) {
            switch (index % 3) {
                case 1: return 'pink';
                case 2: return 'blue';
                default: return 'primary'
            }
        },
        // 点击服务包下的服务项
        clickServicePackChild (val) {
            if (val.remainingQuantity <= 0) {
                if (val.canContinue == 0) {
                    this.$toast('当前服务项次数已用完')
                    return
                }
            }
            this.$router.push(`/physicianVisits/consult/${val.id}?type=child`)
        }
    }
};
</script>

<style scoped lang="less">
.service_pack_list {
	&__item {
		& + & {
			margin-top: 28px;
		}
		border-radius: 16px;
		&.primary {
			background-color: mix(@primary, #fff, 5%);
		}
		&.blue {
			background-color: #f7fbff;
		}
		&.pink {
			background-color: #f9f7ff;
		}
	}
}
</style>
